import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import { PatchedPagination } from '../services/PatchedPagination.js';
//import MaterialTable, { Column } from "@material-table/core";
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import { withAuthorization } from '../Session';
import * as ROUTES from '../../constants/routes';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import CreateNotifications from './CreateNotifications';

import Multiselect from 'multiselect-react-dropdown';


const columnsAdmin = [
    { title: 'From', field: 'CreatedBy' },
    { title: 'StoreTag', field: 'StoreTag' },
    { title: 'Subject', field: 'title' },
    {
        title: 'Image',
        field: 'messageImg',
        render: (item) => (
            <img src={item.messageImg} alt="" border="0" width="100" />
        )
    },
    { title: 'DateTime', field: 'DateTime' ,render: (item) => getFormattedDateTime(item.DateTime)}
];

const columnsUser = [
    { title: 'Title', field: 'title' },
    { title: 'StoreTag', field: 'StoreTag' },
    { title: 'Message', field: 'messageBody' },
    {
        title: 'Image',
        field: 'messageImg',
        render: (item) => (
            <img src={item.messageImg} alt="" border="0" width="100" />
        )
    },
    { title: 'DateTime', field: 'DateTime',render: (item) => getFormattedDateTime(item.DateTime) }
];

const columnsNotification = [
    { title: 'Name', field: 'Name' },
    { title: 'WhatsAppNumber', field: 'WhatsAppNumber' },
    { title: 'StoreTag', field: 'StoreTag' }
];

const pageSizes = [5, 10, 25, 50, 100];


class AllList extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            perPage: 5,
            pageNumber: 0,
            LastDocument: false,
            FirstDocument: false,
            isLastPage:false,
            StartAt: [],
            moveTo: false,
            DateTime:'',
            search_key: '',
            search_by: 'StoreTag',

            alert: 0,
            alertMessage: '',
            data: [],
            flag: true,
            isTableReady: false,
            showAddEdit: false,
            showDetails: false,
            selectedRow: [],
            tagOptions: [],
            selectedTags: [],
        };
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async loadData() {
        let bodyData = {
            DateTime:this.state.DateTime,
            storeTags: this.state.selectedTags,
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:
                this.props.role == 'StoreOwners'
                    ? 'StoreOwner'
                    : this.props.role,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };
        
        await RestServices.getAllNotifications(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                
                    if(responseData.list.length>0){
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            isLastPage: responseData.list.length <parseInt(this.state.perPage) ? true:false,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            flag: false,
                            isTableReady: true,
                            alert: 0
                        });
                    }
                    
                    }else{
                    if (this._isMounted) {
                        this.setState({
                            isLastPage: true,
                            data:[],
                            flag: false,
                            isTableReady: true,
                            alert: 0
                        });
                    }
                    }
                    
                    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            selectedTags:[],
            tagOptions:[],
            moveTo: false,
            StartAt: [],
            pageNumber: 0,
            DateTime:''
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    cancleAction = () => {
        this.loadData();
        if (this._isMounted) {
            this.setState({ showAddEdit: false });
        }
    };

    hideDetails = () => {
        if (this._isMounted) {
            this.setState({ showDetails: false, selectedRow: '' });
        }
    };


    onSelect = (selectedList, selectedItem) => {
        if (this._isMounted) {
            this.setState({ selectedTags: selectedList });
           
        }
        
    };

    onRemove = (selectedList, removedItem) => {
        if (this._isMounted) {
            this.setState({ selectedTags: selectedList });
            
        }
       
    };
    
    onSearch = async (search_key) => {
        let bodyData = {
            search_key: search_key,
            search_by: 'StoreTag',
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:
                this.props.role == 'StoreOwners'
                    ? 'StoreOwner'
                    : this.props.role,
            perPage: 10
        };
        
        await RestServices.SearchStoreTagsMapping(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (StoreTags) => {
                let tagOptions = [];
                await StoreTags.list.forEach(async (storetag) => {
                    tagOptions.push({ tag: storetag });
                });
                if (this._isMounted) {
                    this.setState({ tagOptions: tagOptions });
                }
            })
            .catch((err) => {});
    };
    
    render() {
        const actions = [
            {
                icon: 'add',
                tooltip: 'Add new',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({ showAddEdit: true });
                    }
                }
            },
            {
                icon: 'preview',
                tooltip: 'View Details',
                onClick: (event, rowData) => {
                    if (rowData.destinations) {
                        
                        let selectedRow = [];

                        if (this._isMounted) {
                            if (rowData.destinations.length > 1) {
                                selectedRow = rowData.destinations;
                            } else {
                                selectedRow.push(rowData.destinations);
                            }
                            // selectedRow= rowData.destinations;

                            this.setState({
                                showDetails: true,
                                selectedMessage: rowData,
                                selectedRow: selectedRow
                            });
                        }
                    }
                }
            }
        ];

        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                {!this.state.showDetails &&
                    !this.state.showAddEdit &&
                    this.state.isTableReady && (
                        <Row style={{ justifyContent: 'right' }}>
                        <Col sm={6}
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right',
                                    zIndex:'9999'
                                }}
                            >
                         <Multiselect
                                            placeholder="Select Store"
                                            options={this.state.tagOptions}
                                            displayValue="tag"
                                            selectedValues={
                                                this.state.selectedTags
                                            }
                                            onSelect={this.onSelect}
                                            onRemove={this.onRemove}
                                            onSearch={this.onSearch}
                                        />   
                        </Col>
                        <Col sm={3}
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right',
                                    zIndex:'9999',
                                    padding:'0px',
                                }}
                            >
                        <Form.Control
                                        placeholder="Select Date"
                                        type="date"
                                        name="DateTime"
                                        value={this.state.DateTime}
                                        onChange={this.onChangeValues}
                                        style={{ height:'45px',width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        
                                    />
                        </Col>
                            <Col sm={3}
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    
                                        
                                    
                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}

                {!this.state.showDetails &&
                    !this.state.showAddEdit &&
                    this.state.isTableReady &&
                    this.props.userRole == 'Admin' && (
                        <MaterialTable
                            title="Notifications"
                            columns={columnsAdmin}
                            data={this.state.data}
                            actions={actions}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />
                    )}

                {!this.state.showDetails &&
                    !this.state.showAddEdit &&
                    this.state.isTableReady &&
                    this.props.userRole != 'Admin' && (
                        <MaterialTable
                            title="Notifications"
                            columns={columnsUser}
                            data={this.state.data}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />
                    )}

                <div>
                    <hr />
                </div>
                {!this.state.showDetails &&
                    !this.state.showAddEdit &&
                    this.state.isTableReady && (
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.isLastPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {!this.state.isLastPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    )}

                {!this.state.showDetails &&
                    this.state.showAddEdit &&
                    this.props.userRole == 'Admin' && (
                        <div>
                            <Row>
                                <KeyboardBackspaceRoundedIcon
                                    style={{ cursor: 'pointer', color: 'blue' }}
                                    onClick={this.cancleAction}
                                />
                                <h4
                                    style={{
                                        marginLeft: '1rem',
                                        marginRight: '1rem'
                                    }}
                                >
                                    Create Notifications
                                </h4>
                            </Row>
                            <div>
                                <hr />
                            </div>

                            <CreateNotifications {...this.props} />
                        </div>
                    )}

                {this.state.showDetails && (
                    <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.hideDetails}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Notifications Details
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>

                        <Row>
                            <Col>
                                <b>From: </b>
                                {this.state.selectedMessage.CreatedBy}
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <b>Title: </b>
                                {this.state.selectedMessage.title}
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <b>Message: </b>
                                {this.state.selectedMessage.messageBody}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <b>Date: </b>
                                {getFormattedDateTime(this.state.selectedMessage.DateTime)}
                            </Col>
                        </Row>

                        <MaterialTable
                            title="Sent To..."
                            columns={columnsNotification}
                            data={this.state.selectedRow}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />
                    </div>
                )}
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(AllList);
